<template>
   <section>

    <input type="checkbox" id="mobile-menu-checkbox">

    <nav role="navigation" class="mobile-menu">
        <div class="drawer-header" @click="closeDrawer" v-on="closeDrawer">
            <i class="fas fa-arrow-left p-2 ic_back">
            </i>
        </div>
        <div id="drawer-menu">
            <div class="img-profile-parent drawer-header">
                <span class="text-white text-xl">Hi</span><br>
                <span class="text-white text-xl capitalize">{{ $page.props.user.name }}</span>
                 <div class="col-6">
                    <div class="">
                        <img src="http://sparshinnovators.in/sparshWebsite/public/nova_images/ic_oyo.svg"
                            class="img-profile rounded-full mt-2" alt="">
                    </div>
                </div>
                <div class="col-6">
                    <span class="text-black text-2xl">Hi</span><br>
                    <span class="text-black text-2xl">Name</span>
                </div>
            </div>
            
            <ul class="menu-parent-ul pl-2" id="menu-parent-ul">
                <li class="menu-parent-li"><jet-nav-link :href="route('dashboard')" class="main-menu-link lead">Home</jet-nav-link></li>
                <li class="menu-parent-li"><jet-nav-link :href="route('app/paytime/home')" class="main-menu-link lead">Paytime</jet-nav-link></li>
                <li class="menu-parent-li"><jet-nav-link :href="route('/')" class="main-menu-link lead">My Account</jet-nav-link></li>
                <li class="menu-parent-li"><jet-nav-link :href="route('/')" class="main-menu-link lead">Notification</jet-nav-link></li>
            
                <!--  Dynamic Menu -->

                <li v-for="(value,key) in mOrder" class="menu-parent-li">
                        <jet-nav-link :href="route('/')" class="main-menu-link lead">
                        {{ value.name }}
                        
                        <span  v-if="isContain(value.id,menuDef)">
                            <jet-nav-link  v-for="(value2,key2) in menuDef[value.id]"
                                :href="route().has(value2.url)? route(value2.url) : '#'" >
                            {{ value2.name }}
                            </jet-nav-link>                                                  
                        </span> 


                        </jet-nav-link>
                </li>
                <hr>
                    <li class="menu-parent-li">
                        <span  v-for="(value2,key2) in menuDef[0]">
                            <jet-nav-link v-if="value2.url !='#' "
                            :href="route(value2.url)" class="main-menu-link lead">

                                {{ value2.name }}
                                
                            </jet-nav-link>        
                        </span> 
                    </li> 

                    
                    <!-- 
                <li v-for="(value,key) in mOrder" class="menu-parent-li">
                        <jet-nav-link :href="route('/')" class="main-menu-link lead">{{ value.name }}
                        
                        <div  v-if="isContain(value.id,menuDef)">
                            <jet-nav-link  v-for="(value2,key2) in menuDef[value.id]"
                                :href="route().has(value2.url)? route(value2.url) : '#'" >
                            {{ value2.name }}
                            </jet-nav-link>                                                  
                        </div> 


                        </jet-nav-link>
                </li>
                <hr>
                    <li class="menu-parent-li">
                        <div  v-for="(value2,key2) in menuDef[0]">
                            <jet-nav-link v-if="value2.url !='#' "
                            :href="route(value2.url)">

                                {{ value2.name }}
                                
                            </jet-nav-link>        
                        </div> 
                    </li>
                    -->
                
                <li class="menu-parent-li"><jet-nav-link :href="'#'" v-on:click="logout()" class="main-menu-link lead">Logout</jet-nav-link></li>
            </ul>
        </div>
    </nav>

    <label for="mobile-menu-checkbox" id="mobile-menu-overlay"></label>

    <header class="header pt-2 pb-2">
        <label class="" for="mobile-menu-checkbox" id="mobile-menu-btn">
            <span class="menu-link text-white"><i class="fas fa-bars text-black"></i></span>
        </label>
        <span class="text-grey screen_title lead capitalize ">{{appbarTitle}}</span>
    </header>

</section>
</template>

<style scoped>
 :root {
        --blue: #0068CA;
        --white: #ffffff;
        --primary: #82C5FF;
        --secondary: #FDC031;
        --black: #333333;
        --input_grey: #d7d7d7;
        --hint_grey: #bfbfbf;
        --pink: #FF4B69;
    }
    * {
        outline: none;
    }
 
    /*Scroll - START*/
    /* width */
    ::-webkit-scrollbar {
        width: 5px;
    }
    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }
    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
    }
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
    /*Scroll - END*/

    #drawer-menu{
          overflow: auto;
    }
    
    
        #mobile-menu-checkbox {
            display: none;
            margin: 0px 0px 0px !important;
        }

        #mobile-menu-checkbox:checked ~ #mobile-menu-overlay {
            display: block;
            margin: 0px 0px 0px !important;
        }

        #mobile-menu-checkbox:checked ~ .mobile-menu {
            visibility: visible;
            margin: 0px 0px 0px !important;
            transform: translate3d(0, 0, 0);
        }

        #mobile-menu-overlay {
            background-color: rgba(0, 0, 0, 0.6);
            display: none;
            height: 100%;
            left: 0;
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 100;
        }

        .mobile-menu {
            position: fixed;
            left: 0;
            z-index: 101;
            top: 0;
            visibility: hidden;
            width: 300px;
            height: 100%;
            background: #ffffff;
            color: white;
            transition: all 0.2s;
            transform: translate3d(-100%, 0, 0);
        }

        .mobile-menu h1 {
            color: black;
        }

        #mobile-menu-btn {
            background-color: transparent;
            border: none;
            color: #222;
            font-size: 20px;
            font-weight: 300;
            left: 0;
            line-height: 1.6em;
            position: relative;
            padding: 0;
            margin: 0px 0px 0px !important;
            cursor: pointer;
            -webkit-touch-callout: none;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
        }

        header {
            background-color: #ffffff;
            padding: 0.2em;
            position: fixed;
            z-index: 100;
            width: 100%;
            top: 0;
        }

        header .menu-link {
            color: #333333;
            text-transform: uppercase;
            padding-left: 10px;
            margin-top: auto;
        }

        #items {
            line-height: 1.75;
        }

        .drawer-header{
            background-color: #333333 !important;
        }

        .img-profile-parent {
            border-bottom-right-radius: 40px !important;
            padding-left: 10px !important;
            padding-top: 10px !important;
            padding-bottom: 10px !important;
            
            }

        .ic_back {
            color: #ffffff;
            font-weight: bold;
            font-size: 20px;
        }

        ul {
            padding: 0px 0px 0px 0px;
        }

        .main-menu-link {
            color: #333333 !important;
            font-weight: bold !important;
            line-height: 40px !important;
            padding-left: 10px !important;
            padding-top: 2px !important;
            padding-bottom: 2px !important;
            display:block;
        }

        a:focus {
            text-decoration: none;
        }

        a:active {
            text-decoration: none;
        }

        .btn_back_container{
            background-color: #333333;
        }

        /*This will center the title START*/
        .screen_title {
            margin: 0;
            position: absolute;
            top: 50%;
            left: 50%;
            margin-right: -50%;
            transform: translate(-50%, -50%)
        }

        /*This will center the title END*/


</style>

<script>    
import JetNavLink from "@/Jetstream/NavLink.vue";
import JetApplicationMark from "@/Jetstream/ApplicationMark.vue";
import JetBanner from "@/Jetstream/Banner.vue";
import JetDropdown from "@/Jetstream/Dropdown.vue";
import JetDropdownLink from "@/Jetstream/DropdownLink.vue";
import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";


    export default {
       props: {
            title: String,
            userName: String,
            appbarTitle: String,

        },
         components: {
            Head,
            JetApplicationMark,
            JetBanner,
            JetDropdown,
            JetDropdownLink,
            JetNavLink,
            JetResponsiveNavLink,
            Link,

        },

        
         data() {
        return {
            canRegister:true,
            showingNavigationDropdown: false,
            menuDef : new Object(),
            mOrder : new Object(),
            screenHeight: "",
            ///url: '/', 
        }
    },
    methods: {
         getMenuDef() {
            this.errors = {};
            axios
                .get("/menu/menuDef")
                .then((response) => {
                this.menuDef = response.data.menus
                
                this.mOrder = response.data.mOrder
                })
                .catch((error) => {
                if (error.response.status === 422) {
                    console.log(error);
                //  this.errors = error.response.data.errors || {};
                }
                //alert("error");
                });
    },

        showBackButton(){
            console.log("Back Button Visible");
        },
        logout() {
            this.$inertia.post(route("logout"));
        },

        closeDrawer(){
            document.getElementById("mobile-menu-checkbox").checked = false;
        },
        setSideBarHeight(){
            // alert((app.getScreenHeight()-20));

             try {

                    document.getElementById("drawer-menu").style.height = (app.getScreenHeight()-50)+"px";
                } catch (error) {                       
                    document.getElementById("drawer-menu").style.height = "80vh";

                }
        
        }
  },
  mounted() {
    window.getScreenHeight = this.getScreenHeight;
    this.setSideBarHeight();
   this.getMenuDef();
  },
}
</script>

